<template>
<div class="wholeContext">
  <app-sidebar></app-sidebar>
  <app-header :transDataSet="transDate"></app-header>
  <div class="appContext withWidget">
    <tracking-progress :transDataSet="transDate"></tracking-progress>
    <div class="join container">
      <div class="welcome">
        <h2><img src="@/assets/images/thanq_logo.png"></h2>
        <p>땡큐에 오신것을 환영합니다.</p>
      </div>
      <div class="selectType">
        <label class="type" for="overAge" :class="{active : overAgeChecked}">
          <h3>회원가입</h3>
          <input type="checkbox" id="overAge" name="overAge" class="hideValue" value="overAgeTerms" @click="overAgeSelect" v-model="overAgeChecked"/>
        </label>
        <label class="type" for="underAge" :class="{active : underAgeChecked}">
          <h3>예비 회원 가입</h3>
          <p>본인인증 사용 불가시 회원가입 후 내원하여 사용 가능</p>
          <input type="checkbox" id="underAge" name="underAge" class="hideValue" value="underAgeTerms" @click="underAgeSelect" v-model="underAgeChecked"/>
        </label>
      </div>
    </div>
    <div class="btnWrap" :class="{visible : buttonUp}">
      <button type="button" class="callTerms" @click="nextAuthorized()">다음</button>
    </div>
  </div>
  <add-popup v-if="checkPopup"
             :popupSet="popupSet"/>
</div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import TrackingProgress from '../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '회원타입을 선택해주세요.',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원가입',
        progressNum: '25%',
        chapterNum: 1,
        prevUrl: '/'
      },
      buttonUp: false,
      underAgeChecked: false,
      overAgeChecked: false,
      setCount: false
    }
  },
  created () {
    this.SET_POPUP(false)
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.initData()
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_TERMS',
      'SET_PRIVACY',
      'SET_TEMPORARY_TERMS',
      'SET_TEMPORARY_PRIVACY'
    ]),
    ...mapActions([
      'IDENTITY'
    ]),
    initData () {
      this.SET_TERMS(false)
      this.SET_PRIVACY(false)
      this.SET_TEMPORARY_TERMS(false)
      this.SET_TEMPORARY_PRIVACY(false)
    },
    overAgeSelect () {
      this.overAgeChecked = !this.overAgeChecked
      if (this.underAgeChecked) {
        this.underAgeChecked = !this.underAgeChecked
      } else {
        this.buttonUp = !this.buttonUp
      }
    },
    underAgeSelect () {
      this.underAgeChecked = !this.underAgeChecked
      if (this.overAgeChecked) {
        this.overAgeChecked = !this.overAgeChecked
      } else {
        this.buttonUp = !this.buttonUp
      }
    },
    async nextAuthorized () {
      if (!this.buttonUp) {
        this.SET_POPUP(true)
      } else {
        if (this.underAgeChecked) {
          await this.$router.push('/authorizedTemporary')
        } else {
          await this.IDENTITY()
            .then(() => {
              this.$router.push('/authorized')
            })
        }
      }
    },
    callPrev () {
      const currentLocation = document.location.href
      const mainLocate = currentLocation.substring(currentLocation.length, currentLocation.length - 11)
      if (sessionStorage.getItem('pathToLoadUnAuth') === mainLocate) {
        if (this.setCount) {
          if (sessionStorage.getItem('pathFromLoadUnAuth') === '/telReservation_step1') {
            this.$router.push('/telReservation_step1')
          } else {
            this.$router.push('/login')
          }
        } else {
          history.go(1)
        }
        this.setCount = true
        // 클로즈 함수 구현
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/main';
</style>
